//使用mock.js提供mock数据接口
import Mock from 'mockjs'
import data from './data.json'


Mock.mock('/users/list?pageNum=1',data.users)

Mock.mock(`/homepage/userArticleChart`,data.userArticleChart)
Mock.mock(`/homepage/plateArticleChart`,data.plateArticleChart)
Mock.mock(`/homepage/number`,data.allnumber)
Mock.mock(`/homepage/newFive`,data.newFive)

Mock.mock('/users/toplateuser',data.plateUserList)

Mock.mock('/plates/list?pageNum=1',data.plates)
Mock.mock('/plates/list?pageNum=2',data.plates2)
Mock.mock('/plates/list?pageNum=3',data.plates3)
Mock.mock('/plates/list?pageNum=4',data.plates4)
Mock.mock('/plates/list?pageNum=5',data.plates5)

Mock.mock('/articles/list',data.articles)

Mock.mock('/commons/list',data.comments)

Mock.mock('/plates/addplate' ,data.addplate)
Mock.mock('/plates/allplatename' ,data.allplatename)

Mock.mock('/users/adduser' ,data.adduser)

Mock.mock(RegExp('/users/userdetail/' + ".*") ,data.userdetail)
//应该使用正则表达式

Mock.mock(RegExp('/plates/platedetail/'+'.*') ,data.platedetail)
//应该使用正则表达式

// Mock.mock('/plates/editplate/1',data.editplate)
Mock.mock(RegExp('/plates/editplate/'+'.*'),data.editplate)

Mock.mock(RegExp('/plates/deleteplate/'+'.*'),data.delete)

Mock.mock(RegExp('/plates/deleteplate/'+'.*'),data.delete)
Mock.mock(RegExp('/users/logout'+'.*'),data.delete)

Mock.mock(RegExp('/users/deleteuser/'+'.*'),data.delete)

Mock.mock(RegExp('/users/deleteusers/'+'.*'),data.delete)

Mock.mock(RegExp('/plates/noplateuser/'+'.*'),data.noplateuser)

Mock.mock(RegExp('/comments/deletecomment/'+'.*'),data.delete)

Mock.mock(RegExp('/users/edituserinfo/'+'.*'),data.delete)

Mock.mock(RegExp('/comments/deletecomments/'+'.*'),data.delete)

Mock.mock("/articles/addcomment",data.delete)

Mock.mock(RegExp('/plates/searchplate'+'.*'),function () {
  let list =Mock.mock( {
    "searchplate|15":[
      {
        "plate_name": "版块名称@cword(2)",
        "id|1-100": 10,
        "description":"描述@csentence",
        "moderator_name":"@cname",
        "update_time":"@datetime",
        "postNum|1-1000":20
      }
    ]
  })
  return list.searchplate
})

Mock.mock(RegExp('/users/searchuser'+'.*'),function () {
  let list =Mock.mock( {
    "searchuser|15":[
    {
      "nick_name": "@cname",
      "id|+1": 1,
      "sex|1":["女","男"],
      "email":"@email",
      "update_time":"@date",
      "signature":"@csentence",
      "integral|1-3000":566,
      "role_name|1":["普通用户"],
      "plate_id":4,
      "plate_name":"谭佳版块",
      "postNum|1-100":100
    }]
  })
  return list.searchuser
})

Mock.mock(RegExp('/articles/searcharticle'+'.*'),function () {
  let list =Mock.mock({
    "searcharticle|10":[
      {
        "id|+1":1,
        "title": "@ctitle(5,20)",
        "nick_name": "@cname",
        "plate_name|1":["学习版块","游戏版块","考研版块","Java版块","Vue版块"],
        "update_time":"@datetime",
        "comment_num|1-500":20,
        "click_num|1-50":20,
        "is_top":0
      }
    ]
  })
  return list.searcharticle
})

Mock.mock(RegExp('/comments/searchcomment'+'.*'),function () {
  let list = Mock.mock({
    "searchcomment|5":[
      {
        "id|+1":1,
        "topic_id|1-10":1,
        "topic":"@ctitle(5.20)",
        "nick_name":"@cname",
        "content":"@csentence",
        "comment_type|0-2":1
      }
    ]
  })
  return list.searchcomment
})

Mock.mock(RegExp('/articles/articledetail'+'.*'),data.articleDetail)

Mock.mock(RegExp('/articles/deletearticle'+'.*'),data.delete)

Mock.mock(RegExp('/plates/deletearticles'+'.*'),data.delete)

Mock.mock(RegExp('/users/loginuserinfo'+'.*'),data.loginUser)

Mock.mock(RegExp('/plates/plateUserPlateList'+'.*'),data.plateUserPlateList)
Mock.mock(RegExp('/articles/plateUserArticleList'+'.*'),data.plateUserArticleList)
Mock.mock(RegExp('/comments/plateUserCommontList'+'.*'),data.plateUserCommontList)

Mock.mock('/users/login',data.login)




// WEBPACK FOOTER //
// ./src/mock/mockServer.js